import { Flex, Space, Text, Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { INVOICE_MESSAGE_CHARACTER_LIMIT } from '@features/invoices/constants/invoiceMessageCharacterLimit'
import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const DefaultInvoiceMessage = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem, watch } = useFormContext<InvoiceSettingsFormSchema>()

  const message = watch('message')

  const handleDebouncedInvoiceMessageChange = useDebouncedCallback(() =>
    trackInvoicingSettings('Content Message Typed'),
  )

  return (
    <FormItem
      name="message"
      label={
        <Flex justifyContent="space-between">
          <Text colorVariant="secondary">
            {t('settings.organization.external_invoice.content.default_invoice_message.label')}
          </Text>
          <Space size="s24" horizontal />
          <Text colorVariant="secondary">{`${message.length}/${INVOICE_MESSAGE_CHARACTER_LIMIT}`}</Text>
        </Flex>
      }
      render={({ field: { onChange, ...rest } }) => {
        return (
          <Textarea
            {...rest}
            expandOnType
            maxHeight={160}
            maxLength={INVOICE_MESSAGE_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedInvoiceMessageChange()
            }}
            placeholder={t('settings.organization.external_invoice.content.default_invoice_message.placeholder')}
            resizable={false}
            rows={1}
          />
        )
      }}
    />
  )
}
